module.exports = __webpack_public_path__ + "img/sponsor-revive-logo.f5b87d4f.jpg";